var map = {
	"./additional-activities-icon.svg": "5179",
	"./admin-icon.svg": "7021",
	"./alert-icon.svg": "cc79",
	"./analysis-icon.svg": "e94f",
	"./arrow-down-gray-icon.svg": "d8a0",
	"./arrow-down-icon.svg": "5c01",
	"./arrow-left-icon.svg": "1bc7",
	"./assets/icon/checkbox-icon.svg": "d9d7",
	"./assets/icon/lock-icon.svg": "076f",
	"./assets/icon/radiobutton-icon.svg": "aa5d",
	"./assets/icon/search-icon.svg": "631f",
	"./assets/icon/user-icon.svg": "7f2e",
	"./close-icon.svg": "910f",
	"./delete-icon.svg": "eb03",
	"./doc-file-icon.svg": "cbdd",
	"./download-file-icon.svg": "9ebeb",
	"./file-upload-icon.svg": "cda9",
	"./get-risk-icon.svg": "a241",
	"./info-icon.svg": "fe75",
	"./mail-icon.svg": "d29c",
	"./map-upload-icon.svg": "0c47",
	"./minus-icon.svg": "9781",
	"./notification-icon.svg": "ead3",
	"./plus-icon.svg": "a0f9",
	"./project-menu-icon.svg": "227a",
	"./reload-icon.svg": "c3db",
	"./ruler-icon.svg": "3320",
	"./select-info-icon.svg": "6e55",
	"./set-scale-icon.svg": "d583",
	"./settings-icon.svg": "1a83",
	"./substrate-upload-icon.svg": "aa07",
	"./upload-icon.svg": "41f6",
	"./user-icon.svg": "b3f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4286";